import styled from "styled-components";

export const EventDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: ${({ colors }) => colors[5].color};

  .event-info {
    display: flex;
    align-items: center;

    &__text {
      font-size: 16px;
      font-weight: 600;
      color: #717171;
    }

    &__dot {
      width: 4px;
      height: 4px;
      border-radius: 2px;
      margin: 0 10px;
      background-color: ${({ colors }) => colors[5].color};
    }
  }

  .event-description {
    &__content {
      font-size: 14px;
      color: ${({ colors }) => colors[5].color};
    }

    &__empty-message {
      font-size: 14px;
      color: #717171;
    }
  }

  .event-relations {
    &__title {
      font-size: 14px;
      font-weight: 600;
    }

    &__list {
      margin-bottom: 12px;
      list-style: none;
      padding-left: 0;
      li {
        margin: 6px 0;
        font-size: 14px;
      }
    }
    
  }

  .divider {
  }
`;

